"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVEN_PRODUCT_DISPLAY_NAMES = exports.AvenProductType = void 0;
const depositProductNames_1 = require("./deposit/depositProductNames");
const onboarding_1 = require("./deposit/onboarding");
/**
 * Canonical set of product offer categories used across the product.
 * These values are not specific to third-party lead flows.
 */
var AvenProductType;
(function (AvenProductType) {
    AvenProductType["HOME_EQUITY_CASH"] = "homeEquityCash";
    AvenProductType["HOME_EQUITY_CARD"] = "homeEquityCard";
    AvenProductType["FLEX_CARD"] = "flexCard";
    AvenProductType["MORTGAGE"] = "mortgage";
    AvenProductType["FIRST_LIEN_HELOC"] = "firstLienHeloc";
    AvenProductType["HOME_PURCHASE_HELOC"] = "homePurchaseHeloc";
    AvenProductType["REWARDS_CARD"] = "rewardsCard";
    AvenProductType["DEPOSIT"] = "deposit";
    AvenProductType["CRYPTO_CARD"] = "cryptoCard";
})(AvenProductType || (exports.AvenProductType = AvenProductType = {}));
exports.AVEN_PRODUCT_DISPLAY_NAMES = {
    [AvenProductType.HOME_EQUITY_CARD]: 'Home Equity Card',
    [AvenProductType.HOME_EQUITY_CASH]: 'Home Equity Cash',
    [AvenProductType.FLEX_CARD]: 'Flexible Cash',
    [AvenProductType.REWARDS_CARD]: 'Rewards Card',
    [AvenProductType.FIRST_LIEN_HELOC]: 'First Lien HELOC',
    [AvenProductType.HOME_PURCHASE_HELOC]: 'Home Purchase HELOC',
    [AvenProductType.MORTGAGE]: 'Mortgage',
    [AvenProductType.DEPOSIT]: (0, depositProductNames_1.getDepositProductNames)(onboarding_1.DepositOnboardingSource.DEFAULT).shortDepositProductName,
    [AvenProductType.CRYPTO_CARD]: 'Bitcoin Card',
};
